var map = {
	"./components/components.module": [
		"./src/app/components/components.module.ts",
		"components-components-module"
	],
	"./dashboard/admin-dashboard/dashboard.module": [
		"./src/app/dashboard/admin-dashboard/dashboard.module.ts",
		"dashboard-admin-dashboard-dashboard-module"
	],
	"./dashboard/club-dashboard/dashboard.module": [
		"./src/app/dashboard/club-dashboard/dashboard.module.ts",
		"dashboard-club-dashboard-dashboard-module"
	],
	"./dashboard/committee-dashboard/dashboard.module": [
		"./src/app/dashboard/committee-dashboard/dashboard.module.ts",
		"dashboard-committee-dashboard-dashboard-module"
	],
	"./dashboard/company-dashboard/dashboard.module": [
		"./src/app/dashboard/company-dashboard/dashboard.module.ts",
		"dashboard-company-dashboard-dashboard-module"
	],
	"./dashboard/society-dashboard/dashboard.module": [
		"./src/app/dashboard/society-dashboard/dashboard.module.ts",
		"dashboard-society-dashboard-dashboard-module"
	],
	"./dashboard/tour-dashboard/dashboard.module": [
		"./src/app/dashboard/tour-dashboard/dashboard.module.ts",
		"dashboard-tour-dashboard-dashboard-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;